import Box from '@mui/material/Box';
import React, { memo } from 'react';
import { useIntl } from 'react-intl';

import IconVehiclesBus from '../Icons/Vehicles/IconVehiclesBus';
import IconVehiclesCamper from '../Icons/Vehicles/IconVehiclesCamper';
import IconVehiclesCaravan from '../Icons/Vehicles/IconVehiclesCaravan';
import IconVehiclesCarTent from '../Icons/Vehicles/IconVehiclesCarTent';
import IconVehiclesMotorHome from '../Icons/Vehicles/IconVehiclesMotorHome';
import IconVehiclesTent from '../Icons/Vehicles/IconVehiclesTent';
import IconVehiclesVan from '../Icons/Vehicles/IconVehiclesVan';
import ItemChip from './ItemChip';

const getIcon = (optionKey) => {
  switch (optionKey) {
    case 'bus':
      return <IconVehiclesBus />;
    case 'camper':
      return <IconVehiclesCamper />;
    case 'caravan':
      return <IconVehiclesCaravan />;
    case 'carTent':
      return <IconVehiclesCarTent />;
    case 'motorhome':
      return <IconVehiclesMotorHome />;
    case 'tent':
      return <IconVehiclesTent />;
    case 'van':
      return <IconVehiclesVan />;
    default:
      return null;
  }
};

const vehiclesPropertyGroupDefaultPropSelectedOptions = [];

/**
 * AmenitiesPropertyGroup renders a list of options as chips, indicating selected and non-selected items.
 *
 * It's used for displaying a group of selectable properties, such as amenities or activities,
 * in a form where users can see their current selections at a glance.
 *
 * Props:
 *   - id (string): A unique identifier for the group of options.
 *   - options (array): An array of option objects, each containing a `key` and `label`.
 *   - selectedOptions (array): An array of selected option keys.
 *   - intl (object): The internationalization object provided by react-intl's `injectIntl`.
 *   - showNotSelectedItems (bool): Flag to show or hide non-selected items.
 *
 * Each option is rendered as an `ItemChip` component, which is responsible for the actual display
 * of the chip.
 */
const VehiclesPropertyGroup = ({ options, selectedOptions = vehiclesPropertyGroupDefaultPropSelectedOptions, showNotSelectedItems = true }) => {
  const intl = useIntl();
  return (
    <Box>
      {options.map((option) => (
        <ItemChip
          icon={getIcon(option.key)}
          isSelected={selectedOptions.includes(option.key)}
          key={`${option.key}`}
          label={intl.formatMessage({ id: option.label })}
          showNotSelectedItems={showNotSelectedItems}
        />
      ))}
    </Box>
  );
};

export default memo(VehiclesPropertyGroup);
